export default __webpack_public_path__ + "static/media/Shohag-Junior front end-developer-Resume .1e25e520.pdf";